import { Navigate } from 'react-router-dom';
import { LoginScreen, type LoginBranding } from '@techsofit/ui';
import { api, useAuth, loginErrorMessage } from '@techsofit/app-kit';
import heroImage from '@/assets/gym-hero-mood.jpg';

const BRANDING: LoginBranding = {
  panelEyebrow: 'Platform console',
  panelHeading: 'Every gym on TechSoFit, overseen from one place.',
  panelBody:
    'Provision gyms, manage platform users, record SaaS billing, and support tenants with fully audited, read-only impersonation.',
  panelFootnote: 'Your account is protected with secure sign-in.',
  formEyebrow: 'Platform admin',
  formHeading: 'Sign in to the console',
  formSubtext: 'Restricted to TechSoFit platform administrators.',
  emailPlaceholder: 'you@techsolutely.co.zw',
  formFootnote: 'Secure sign-in for the Techsolutely team.',
};

export function LoginPage() {
  const { status } = useAuth();

  // Already signed in (e.g. opened /login directly) — skip the form.
  if (status === 'authenticated') {
    return <Navigate to="/" replace />;
  }

  return (
    <LoginScreen
      branding={BRANDING}
      image={heroImage}
      resolveError={loginErrorMessage}
      onSubmit={async (credentials) => {
        // Platform admins sign in with a password on the account model. A full reload
        // lets the AuthProvider bootstrap from the (now platform) account session.
        await api('/account-auth/password-login', { method: 'POST', body: credentials });
        window.location.assign('/');
      }}
    />
  );
}
